// Programme catalog — config-driven so DE/EN switching is trivial and
// adding a 4th programme later is just a new entry.

export const PROGRAMMES = {
  "sat-master": {
    key: "sat_master",
    slug: "sat-master",
    accent: "#D4AF37",
    bg: "/brand/nenad-cosmic.jpg",
    duration_months: 6,
    price_full_chf: 5990,
    price_3rate_chf: 2000,
    bundle_with: "sat-mentor",
    bundle_price: 12500,
    bundle_3rate: 4170,
    sales_mode: "checkout", // direct checkout + optional application
    product_keys: { full: "sat_master_full", r3: "sat_master_3rate" },
    course_slug: "sat-master",
    de: {
      kicker: "SAT Transformations Master™ · 6-Monats-Prozess",
      title: "Die Spielregeln",
      title2: "des Lebens.",
      headline: "Vom unbewussten Reagieren zum bewussten Erschaffen.",
      lead: "Eine ganzheitliche Ausbildung zur persönlichen Transformation. Vier Phasen — Erkennen · Heilen · Transformation · Erschaffen — über zwölf Tiefen-Module in sechs Monaten.",
      pitch: "SAT Transformations Master™ verbindet Psychologie, Persönlichkeitsentwicklung, systemische Arbeit, Human Design, Bewusstseinsforschung, Beziehungs- und Berufungsarbeit zu einem einzigen Weg. Du lernst, die verborgenen Zusammenhänge deines Lebens zu erkennen und bewusst zu gestalten. Nicht: jemand anderes zu werden. Sondern: alles loszulassen, was du niemals warst.",
      who_for_title: "Für wen ist SAT Transformations Master™?",
      who_for: [
        "Menschen mitten im Leben, die spüren: so kann es nicht weitergehen.",
        "Erfolgreiche, die innerlich erschöpft sind und nicht mehr nur funktionieren wollen.",
        "Frauen und Männer in Lebens-Übergängen: Trennung · Sinnkrise · Neuanfang.",
        "Menschen, die alles probiert haben — Therapie, Coaching, Bücher — und endlich Tiefe wollen, nicht noch ein Werkzeug.",
      ],
      promise_title: "Was sich in dir verändert.",
      promises: [
        { t: "Klarheit statt Nebel", d: "Du weisst wieder, wer du bist, was du willst und was du nicht mehr trägst." },
        { t: "Beziehungen, die nähren", d: "Auf Augenhöhe, mit klaren Grenzen, in echter Verbindung." },
        { t: "Energie, die zurückkehrt", d: "Dein Körper darf entspannen, weil dein Geist endlich entscheidet, wo er hingehört." },
        { t: "Innere Freiheit", d: "Frei von Schuld, Pflicht und der Stimme deiner Eltern. Frei für ein Leben, das deins ist." },
      ],
      curriculum_title: "4 Phasen · 12 Module · 6 Monate",
      curriculum: [
        { n: "P1", t: "Phase 1 · Erkenne dich selbst", d: "Beobachter · Körper · Gefühle." },
        { n: "01", t: "Der Beobachter", d: "Bevor du verändern kannst, musst du beobachten lernen." },
        { n: "02", t: "Die Sprache des Körpers · Lebensgeschichte entschlüsseln", d: "Körper als Botschafter. Biografie als Karte." },
        { n: "03", t: "Die Welt der Gefühle", d: "Acht Tore zu deiner Tiefe. Fühlen statt verdrängen." },
        { n: "P2", t: "Phase 2 · Heilung", d: "Inneres Kind · Versöhnung · Selbstliebe." },
        { n: "04", t: "Das innere Kind", d: "Sehen · Verstehen · Lieben — das Kind, das in dir wartet." },
        { n: "05", t: "Versöhnung", d: "Verstehen → Annehmen → Vergeben → Loslassen → Frieden." },
        { n: "06", t: "Selbstwert & Selbstliebe", d: "„Ich bin bereit, mich vollständig anzunehmen.\"" },
        { n: "P3", t: "Phase 3 · Transformation", d: "Spiegelgesetze · Unsichtbarer Faden™ · Human Design." },
        { n: "07", t: "Die Spielregeln des Lebens", d: "Bewusstsein · Verantwortung · Entwicklung · Liebe." },
        { n: "08", t: "Der Unsichtbare Faden™", d: "Wurzel · Stamm · Krone · Frucht — die Architektur deines Lebens." },
        { n: "09", t: "Human Design & Potenzial", d: "Typ · Autorität · Profil · Lebensaufgabe." },
        { n: "P4", t: "Phase 4 · Erschaffen", d: "Beziehungen · Berufung · Meisterschaft." },
        { n: "10", t: "Beziehungen meistern", d: "Die grösste Schule des Lebens." },
        { n: "11", t: "Berufung leben", d: "Talent + Leidenschaft + Nutzen + Beitrag = Berufung." },
        { n: "12", t: "Meisterschaft & Vermächtnis", d: "Die 8 Lebensbereiche · Dein Vermächtnis · Abschluss-Zeremonie." },
      ],
      inclusions_title: "Was alles enthalten ist.",
      inclusions: [
        "12 Tiefen-Module mit Video-Lehre, Workbook und Übungen",
        "6 monatliche Live-Group-Calls mit Nenad (max. 24 Teilnehmer)",
        "Persönliche 1:1-Kickoff-Session (60 Min.)",
        "SAT-Master-Workbook (digital · 180+ Seiten)",
        "Tägliche „Spielregel\" via SAT-App",
        "Lebenslanger Zugang zu allen Inhalten",
        "Private Master-Community (Forum + Telegram)",
        "SAT Master Zertifikat nach Abschluss",
      ],
      faq: [
        { q: "Wie viel Zeit pro Woche brauche ich?", a: "Rechne mit 2–4 Stunden pro Woche. Wer mehr investiert, transformiert tiefer — doch der Prozess wirkt auch bei minimalem Aufwand, weil er auf Erkenntnis aufbaut, nicht auf Leistung." },
        { q: "Was, wenn ich nicht alles schaffe?", a: "Du hast lebenslangen Zugang. Niemand zwingt dich durch. Wir bauen Halt, keine Hetze." },
        { q: "Kann ich später noch das Mentor-Programm dazu nehmen?", a: "Ja — wer Master zuerst kauft und sich später für Mentor entscheidet, bezahlt nur die Differenz zum Bundle-Preis." },
        { q: "Gibt es eine Geld-zurück-Garantie?", a: "14 Tage Reflexionszeit nach Start. Wenn du nach Modul 1 spürst, dass es nicht passt, erstatten wir vollständig." },
      ],
      cta_primary: "Jetzt starten",
      cta_secondary: "Bewerbungsgespräch buchen",
    },
    en: {
      kicker: "SAT Master · 6-month process",
      title: "The Rules",
      title2: "of Life.",
      headline: "Your personal transformation process.",
      lead: "Six months to truly meet yourself. Twelve deep modules. A clear path — from where you are to who you're becoming.",
      pitch: "SAT Master is not a course you consume. It's a path you walk — supported, held, guided. We take the themes you've avoided your entire life and turn them into your greatest source.",
      who_for_title: "Who is SAT Master for?",
      who_for: [
        "Mid-life adults who sense: this can't continue.",
        "Successful people who are inwardly exhausted — done with merely functioning.",
        "Women and men in transitions: separation · meaning crisis · new beginning.",
        "Those who've tried everything — therapy, coaching, books — and want depth, not another tool.",
      ],
      promise_title: "What shifts inside you.",
      promises: [
        { t: "Clarity instead of fog", d: "You remember who you are, what you want and what you no longer carry." },
        { t: "Relationships that nourish", d: "Instead of constant giving, you learn to be in relationship — eye to eye, with clear boundaries, in real connection." },
        { t: "Energy that returns", d: "Your body relaxes because your mind finally decides where it belongs." },
        { t: "Inner freedom", d: "Free from guilt, duty, and your parents' voice. Free for a life that is truly yours." },
      ],
      curriculum_title: "12 modules · 6 months · 1 journey",
      curriculum: [
        { n: "01", t: "The honest assessment", d: "Where do you really stand — beyond the stories?" },
        { n: "02", t: "Your childhood inheritance", d: "What you live today often isn't yours. We separate it." },
        { n: "03", t: "The self-worth code", d: "Self-worth as decision — and as muscle." },
        { n: "04", t: "Relationship as mirror", d: "What you see in the other is an invitation." },
        { n: "05", t: "Body as guide", d: "Your body doesn't lie. Learn to listen again." },
        { n: "06", t: "Money · worth · abundance", d: "Money is relationship. With yourself first." },
        { n: "07", t: "Meaning & calling", d: "A job is what you do. A calling does you." },
        { n: "08", t: "Shadow & light", d: "What you don't accept rules you." },
        { n: "09", t: "Boundaries with love", d: "A boundary is a yes to yourself." },
        { n: "10", t: "Decision & consequence", d: "You become what you decide." },
        { n: "11", t: "Love as daily practice", d: "Love is an act, not a feeling." },
        { n: "12", t: "Integration & vision", d: "Who are you now — what comes next?" },
      ],
      inclusions_title: "Everything included.",
      inclusions: [
        "12 deep modules — video lessons, workbook, practices",
        "6 monthly live group calls with Nenad (max. 24)",
        "Personal 1:1 kickoff session (60 min)",
        "SAT Master workbook (digital · 180+ pages)",
        "Daily 'Rule of Life' via SAT app",
        "Lifetime access to all content",
        "Private Master community (forum + Telegram)",
        "SAT Master certificate upon completion",
      ],
      faq: [
        { q: "How much time per week?", a: "Plan for 2–4 hours per week. More investment = deeper transformation, but the process works even with minimal effort, because it builds on insight, not performance." },
        { q: "What if I can't finish?", a: "You have lifetime access. No one pushes you through. We build support, not pressure." },
        { q: "Can I add the Mentor programme later?", a: "Yes — those who start with Master can add Mentor later for only the bundle difference." },
        { q: "Money-back guarantee?", a: "14 days reflection period after start. If after module 1 it doesn't fit, we refund in full." },
      ],
      cta_primary: "Start now",
      cta_secondary: "Book a clarity call",
    },
  },

  "sat-mentor": {
    key: "sat_mentor",
    slug: "sat-mentor",
    accent: "#4B2E83",
    bg: "/brand/nenad-vest.jpg",
    duration_months: 9,
    price_full_chf: 7990,
    price_3rate_chf: 2670,
    sales_mode: "application_first", // application + call required before checkout
    product_keys: { full: "sat_mentor_full", r3: "sat_mentor_3rate" },
    course_slug: "sat-mentor-life-mastery",
    de: {
      kicker: "SAT Mentor · Life Mastery",
      title: "Innere",
      title2: "Freiheit.",
      headline: "Die Premium-Ausbildung für künftige SAT Mentor:innen.",
      lead: "Werde Begleiter:in echter Transformation. Methodisch fundiert. Ethisch klar. In deiner eigenen inneren Freiheit verwurzelt.",
      pitch: "Die SAT Mentor Life-Mastery-Ausbildung ist für Menschen gedacht, die mehr wollen als ein Zertifikat. Sie ist für die, die spüren: meine Berufung ist, andere durch ihre Tiefe zu tragen — sicher, ethisch, wirksam.",
      who_for_title: "Für wen ist diese Ausbildung?",
      who_for: [
        "Menschen, die das Mentoring zu ihrer Berufung machen möchten — als Selbstständige oder im Beruf.",
        "Coaches · Therapeut:innen · Trainer:innen, die ihre Praxis um die SAT-Tiefe erweitern wollen.",
        "Führungskräfte, die ihre Teams nicht nur leiten, sondern begleiten möchten.",
        "Absolvent:innen von SAT Master — der natürliche nächste Schritt.",
      ],
      promise_title: "Wer du am Ende dieser Ausbildung bist.",
      promises: [
        { t: "Ein verkörperter Mentor", d: "Du trägst, was du gelehrt bekommen hast — nicht nur im Kopf, sondern in jeder Zelle." },
        { t: "Methodisch sicher", d: "Du beherrschst 25+ Werkzeuge der Begleitung — und weisst genau, wann welches." },
        { t: "Ethisch klar", d: "Du kennst deine Grenzen. Du erkennst, wann du übergibst. Du arbeitest sicher." },
        { t: "Wirtschaftlich frei", d: "Du weisst, wie du als Mentor:in ein nachhaltiges Einkommen aufbaust — ohne deine Tiefe zu verkaufen." },
      ],
      curriculum_title: "12 Module · 9 Monate · Inkl. 4 Präsenz-Tage",
      curriculum: [
        { n: "01", t: "Die Haltung des Mentors", d: "Bevor du andere begleitest — kannst du dich halten?" },
        { n: "02", t: "Bewusstseinsforschung als Praxis", d: "Lerne, Bewusstsein zu lesen." },
        { n: "03", t: "Spielregeln · Mastery", d: "Verkörperte Lehrkompetenz." },
        { n: "04", t: "Begleitung von Veränderungsprozessen", d: "Sieben Phasen der Transformation." },
        { n: "05", t: "Schatten-Arbeit (sicher & ethisch)", d: "Tiefen-Arbeit mit klaren Grenzen." },
        { n: "06", t: "Körper-orientierte Begleitung", d: "Somatic Awareness für Mentoren." },
        { n: "07", t: "Kommunikation als Heilkunst", d: "Worte, die öffnen statt schliessen." },
        { n: "08", t: "Trauma-informiertes Arbeiten", d: "Erkennen — und wissen, wann du übergibst." },
        { n: "09", t: "Gruppen-Mentoring & Workshops", d: "Vom 1:1 zur transformativen Gruppe." },
        { n: "10", t: "Business & Positionierung", d: "Sinn und Geld als Geschwister." },
        { n: "11", t: "Supervision & Selbstpflege", d: "Wer andere trägt, muss getragen sein." },
        { n: "12", t: "Zertifizierung & Praxis-Start", d: "Live-Case mit Supervision · Mentor-Manifest · Zertifikat." },
      ],
      inclusions_title: "Was die Ausbildung umfasst.",
      inclusions: [
        "12 Tiefen-Module mit Video-Lehre, Skripten, Workbooks",
        "9 monatliche Live-Mentor-Calls mit Nenad (max. 16 Teilnehmer)",
        "4 Präsenz-Tage in der Schweiz (Frühling + Herbst Intensiv-Retreats)",
        "Praxis-Supervision: 6 begleitete Live-Sessions mit Trainings-Klienten",
        "Methoden-Bibliothek: 25+ Mentor-Werkzeuge",
        "Business-Toolkit: Positionierung · Preise · Kunden-Acquise",
        "Peer-Mentoring-Gruppe: ein Begleiter:in für deine ganze Ausbildung",
        "SAT-Mentor-Zertifikat nach bestandener Live-Prüfung",
        "Lebenslanger Zugang zur Mentor-Community + jährliches Update",
      ],
      faq: [
        { q: "Brauche ich Vorkenntnisse?", a: "Lebenserfahrung. Und die Bereitschaft, deine eigene Tiefe vor der deiner Klienten zu betreten. SAT Master ist empfohlen, aber nicht zwingend." },
        { q: "Wie viel Zeit pro Woche?", a: "Plane mit 4–6 Stunden pro Woche, plus die vier Präsenz-Tage." },
        { q: "Gibt es nach Abschluss eine Mentor-Lizenz?", a: "Ja. Du wirst zertifizierte:r SAT Mentor:in mit eigenem Profil auf sat-akademie.com und 30% Provision auf alle vermittelten SAT-Produkte." },
        { q: "Warum ein Bewerbungsverfahren?", a: "Weil wir nicht jeden ausbilden. Wir wählen Menschen, deren Berufung mit unserer Mission resoniert. Die Bewerbung schützt sie und uns." },
      ],
      cta_primary: "Jetzt bewerben",
      cta_secondary: "Mehr erfahren",
    },
    en: {
      kicker: "SAT Mentor · Life Mastery",
      title: "Inner",
      title2: "Freedom.",
      headline: "The premium training for future SAT mentors.",
      lead: "Become a companion of real transformation. Methodically grounded. Ethically clear. Rooted in your own inner freedom.",
      pitch: "The SAT Mentor Life-Mastery training is for people who want more than a certificate. It's for those who sense: my calling is to hold others through their depth — safely, ethically, effectively.",
      who_for_title: "Who is this for?",
      who_for: [
        "People making mentoring their calling — full-time or alongside.",
        "Coaches · therapists · trainers who want to add SAT depth to their practice.",
        "Leaders who want not just to lead but to accompany.",
        "SAT Master graduates — the natural next step.",
      ],
      promise_title: "Who you become.",
      promises: [
        { t: "An embodied mentor", d: "You carry what you've been taught — not just in your head, but in every cell." },
        { t: "Methodically sound", d: "You master 25+ companionship tools — and know exactly when to use which." },
        { t: "Ethically clear", d: "You know your limits. You recognise when to refer. You work safely." },
        { t: "Economically free", d: "You know how to build sustainable income as a mentor — without selling your depth." },
      ],
      curriculum_title: "12 modules · 9 months · incl. 4 in-person days",
      curriculum: [
        { n: "01", t: "The mentor's stance", d: "Can you hold yourself before holding others?" },
        { n: "02", t: "Consciousness as practice", d: "Learn to read consciousness." },
        { n: "03", t: "Rules of life · mastery", d: "Embodied teaching competence." },
        { n: "04", t: "Guiding transformation", d: "Seven phases of change." },
        { n: "05", t: "Shadow work (safe & ethical)", d: "Depth work with clear boundaries." },
        { n: "06", t: "Body-oriented companionship", d: "Somatic awareness for mentors." },
        { n: "07", t: "Communication as art", d: "Words that open instead of close." },
        { n: "08", t: "Trauma-informed work", d: "Recognise — and know when to hand over." },
        { n: "09", t: "Group mentoring & workshops", d: "From 1:1 to transformative groups." },
        { n: "10", t: "Business & positioning", d: "Meaning and money as siblings." },
        { n: "11", t: "Supervision & self-care", d: "Whoever holds others must be held." },
        { n: "12", t: "Certification & launch", d: "Live case · mentor manifesto · certificate." },
      ],
      inclusions_title: "What's included.",
      inclusions: [
        "12 deep modules with video, scripts, workbooks",
        "9 monthly live mentor calls with Nenad (max. 16)",
        "4 in-person days in Switzerland (spring + autumn intensives)",
        "Practice supervision: 6 guided live sessions",
        "Method library: 25+ mentor tools",
        "Business toolkit: positioning · pricing · client acquisition",
        "Peer mentoring buddy throughout",
        "SAT Mentor certificate after passing live exam",
        "Lifetime access + annual updates",
      ],
      faq: [
        { q: "Prerequisites?", a: "Life experience and willingness to walk your own depth before your clients'. SAT Master recommended, not mandatory." },
        { q: "How much time per week?", a: "4–6 hours per week, plus the four in-person days." },
        { q: "Mentor license afterwards?", a: "Yes. Certified SAT Mentor with own profile on sat-akademie.com and 30% commission on referrals." },
        { q: "Why an application?", a: "We don't train everyone. We select people whose calling resonates with our mission. The application protects both sides." },
      ],
      cta_primary: "Apply now",
      cta_secondary: "Learn more",
    },
  },

  "sat-business": {
    key: "sat_business",
    slug: "sat-business",
    accent: "#C9A36A",
    bg: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=2400&q=85",
    duration_months: null,
    price_full_chf: null,
    sales_mode: "inquiry_only", // application only, custom offer
    product_keys: null,
    de: {
      kicker: "SAT Holistic Business Transformation",
      title: "Bewusste",
      title2: "Neuausrichtung.",
      headline: "Die holistische Unternehmensentwicklung.",
      lead: "Für Vorstände, Geschäftsleitungen und Familien-Unternehmen, die nicht nur optimieren — sondern neu denken möchten. Bewusstsein als wirtschaftliche Disziplin.",
      pitch: "Wenn Unternehmen leiden, leiden Menschen. Wenn Menschen wachsen, wachsen Unternehmen. SAT Holistic Business Transformation begleitet Organisationen über 6–18 Monate in eine neue Ausrichtung — kultiviert, klar, kommerziell wirksam.",
      who_for_title: "Für wen ist dieses Programm?",
      who_for: [
        "KMU mit 20–500 Mitarbeitenden, die spüren: die alte Logik trägt nicht mehr.",
        "Familien-Unternehmen in Generationen-Übergängen.",
        "Führungs-Teams nach Fusion, Restrukturierung oder Krise.",
        "Unternehmen, die Sinn und Wirtschaftlichkeit nicht mehr getrennt denken wollen.",
      ],
      promise_title: "Was sich im Unternehmen verändert.",
      promises: [
        { t: "Führung mit Klarheit", d: "Ihre Geschäftsleitung führt aus Bewusstsein, nicht aus Reaktion." },
        { t: "Kultur, die trägt", d: "Mitarbeiter:innen fühlen sich gesehen — Fluktuation sinkt, Engagement steigt." },
        { t: "Strategie mit Sinn", d: "Entscheidungen, die langfristig wirken — wirtschaftlich und menschlich." },
        { t: "Resilienz statt Reaktion", d: "Das Unternehmen wird widerstandsfähig gegen Disruption, weil es weiss, wofür es steht." },
      ],
      curriculum_title: "Die fünf Module der Neuausrichtung",
      curriculum: [
        { n: "I", t: "Standort-Diagnose", d: "Wo steht Ihr Unternehmen — wirtschaftlich, kulturell, menschlich?" },
        { n: "II", t: "Vision-Reset auf C-Level", d: "Wofür sind Sie da? Wofür Ihr Unternehmen? Klärung an der Spitze." },
        { n: "III", t: "Kultur-Architektur", d: "Werte, die nicht an der Wand stehen, sondern gelebt werden." },
        { n: "IV", t: "Führungs-Transformation", d: "Bewusste Führung als Disziplin — vom Top-Management bis zur Schicht." },
        { n: "V", t: "Verankerung & Multiplikation", d: "Damit es bleibt: Strukturen, die das Neue tragen." },
      ],
      inclusions_title: "Was wir gemeinsam tun.",
      inclusions: [
        "Diagnose-Phase: Interviews, Kultur-Audit, Wirtschaftlichkeits-Check (4–6 Wochen)",
        "Maßgeschneiderte Roadmap über 6–18 Monate",
        "C-Level-Begleitung: 2 Tage pro Monat vor Ort + Live-Calls",
        "Führungs-Workshops für mittleres Management",
        "Mitarbeiter-Programme: SAT App, Live-Vorträge, optionale 1:1-Begleitung",
        "Quarterly Reviews mit messbaren KPIs",
        "Persönliche Begleitung durch Nenad & ein 3-köpfiges SAT-Expertenteam",
      ],
      faq: [
        { q: "Wie läuft der Erstkontakt?", a: "Sie senden uns eine Anfrage. Wir vereinbaren ein 60-minütiges Erstgespräch — vertraulich, ohne Verpflichtung. Wenn beide Seiten resonieren, folgt ein Diagnose-Angebot." },
        { q: "Was kostet das?", a: "Jedes Programm ist individuell. Investitionen beginnen bei CHF 60'000 für KMU-Pilotprogramme und reichen bis in den siebenstelligen Bereich für mehrjährige Kultur-Transformationen." },
        { q: "Welche Branchen?", a: "Wir haben Erfahrung in Finance, Pharma, Familienunternehmen, Beratung, Tech und Hospitality — sind aber branchenneutral, weil unsere Arbeit auf Menschen zielt, nicht auf Modelle." },
        { q: "Gibt es Referenzen?", a: "Ja, vertraulich nach NDA. Wir teilen sie nach dem Erstgespräch." },
      ],
      cta_primary: "Erstgespräch anfragen",
      cta_secondary: "Programm-Brochure (PDF)",
    },
    en: {
      kicker: "SAT Holistic Business Transformation",
      title: "Conscious",
      title2: "Realignment.",
      headline: "Holistic corporate development.",
      lead: "For boards, executives and family-owned businesses who don't want to optimise — they want to rethink. Consciousness as an economic discipline.",
      pitch: "When companies suffer, people suffer. When people grow, companies grow. SAT Holistic Business Transformation accompanies organisations for 6–18 months into new alignment — cultivated, clear, commercially effective.",
      who_for_title: "Who is this for?",
      who_for: [
        "SMEs with 20–500 employees sensing: the old logic doesn't hold any more.",
        "Family businesses in generational transitions.",
        "Leadership teams after merger, restructuring, crisis.",
        "Companies who no longer want to separate meaning and economics.",
      ],
      promise_title: "What shifts in the company.",
      promises: [
        { t: "Leadership with clarity", d: "Your executives lead from consciousness, not reaction." },
        { t: "Culture that holds", d: "Employees feel seen — turnover drops, engagement rises." },
        { t: "Strategy with meaning", d: "Decisions that hold up long-term — economically and humanly." },
        { t: "Resilience over reaction", d: "Your company becomes disruption-resistant because it knows what it stands for." },
      ],
      curriculum_title: "The five modules of realignment",
      curriculum: [
        { n: "I", t: "Diagnostic phase", d: "Where does your company stand — economically, culturally, humanly?" },
        { n: "II", t: "C-level vision reset", d: "What are you here for? What is your company for?" },
        { n: "III", t: "Culture architecture", d: "Values that live, not values on a wall." },
        { n: "IV", t: "Leadership transformation", d: "Conscious leadership as discipline." },
        { n: "V", t: "Anchoring & multiplication", d: "Structures that sustain the new." },
      ],
      inclusions_title: "What we do together.",
      inclusions: [
        "Diagnostic phase: interviews, culture audit, economic check (4–6 weeks)",
        "Tailored 6–18-month roadmap",
        "C-level companionship: 2 on-site days/month + live calls",
        "Leadership workshops for middle management",
        "Employee programmes: SAT app, live talks, optional 1:1",
        "Quarterly reviews with measurable KPIs",
        "Personal guidance by Nenad & a 3-person SAT expert team",
      ],
      faq: [
        { q: "How does first contact work?", a: "You send an inquiry. We arrange a 60-minute confidential first call. If both sides resonate, a diagnostic offer follows." },
        { q: "What does it cost?", a: "Every programme is individual. Investments start at CHF 60'000 for SME pilots and extend into seven figures for multi-year culture transformations." },
        { q: "Which industries?", a: "Finance, pharma, family business, consulting, tech, hospitality — but ultimately industry-neutral, because we work with people." },
        { q: "References?", a: "Yes, confidentially under NDA after the first call." },
      ],
      cta_primary: "Request a first call",
      cta_secondary: "Programme brochure (PDF)",
    },
  },
};

export const PROGRAMMES_ORDER = ["sat-master", "sat-mentor", "sat-business"];
